'use strict';

import { CoreRepository } from '../CoreRepository';
import { IndMedicaid } from '../../Entities/Ind/IndMedicaid';
import { IndMedicaidCollection } from '../../Collections/Ind/IndMedicaidCollection';

export class IndMedicaidRepository extends CoreRepository {
  /*public getIndPhone(individualId: number, options: object = {}) {
    if (!options) {
      options = {};
    }
 
    return this.webAPI.getInd(individualId, options)
      .then(response => {
        let user = new Ind();
        user.hydrate(response);
 
        return user;
      });
 
  }
*/

  public createIndMedicaid(indId: number, payload: any[]) {
    return this.webAPI.createIndMedicaid(indId, payload).then((response) => {
      const indMedicaid = new IndMedicaid();
      indMedicaid.hydrate(response);

      return indMedicaid;
    });
  }

  public updateIndMedicaid(indId: number, indMedicaidId: number, payload: any[]) {
    return this.webAPI.updateIndMedicaid(indId, indMedicaidId, payload).then((response) => {
      return response;
    });
  }

  public moveIndMedicaid(individualId: number, individualMedicaidId: number, payload: any[]) {
    return this.webAPI
      .moveIndMedicaid(individualId, individualMedicaidId, payload)
      .then((response) => {
        return response;
      });
  }
}
